import { FormField } from "@/types/shared";

export const inputFields: FormField[] = [
  {
    placeholder: "Select a company",
    type: "text",
    required: true,
    name: "employerID",
    isDropdown: true,
    title: "Company",
    defaultValue: ""
  },
  {
    placeholder: "Select a user role",
    type: "text",
    required: true,
    name: "role",
    isDropdown: true,
    title: "User Role",
    defaultValue: ""
  },
  {
    placeholder: "First Name",
    type: "text",
    required: true,
    name: "firstname",
    title: "First Name",
  },
  {
    placeholder: "Last Name",
    type: "text",
    required: true,
    name: "lastname",
    title: "Last Name",
  },
  {
    placeholder: "Email",
    type: "email",
    required: true,
    name: "mail",
    title: "Email",
    autoComplete: "new-password"
  },
  {
    placeholder: "Password",
    type: "password",
    required: true,
    name: "password",
    title: "Password",
    autoComplete: "new-password"
  },
];
